const DEFAULT_PRODUCTION_API_URL = 'https://manage.swarvinnfoods.co.uk/api';

function isLocalUrl(value) {
  try {
    const hostname = new URL(value).hostname;
    return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1';
  } catch {
    return false;
  }
}

export function getApiBase() {
  if (process.env.NODE_ENV === 'development') {
    return '/api';
  }

  const configured = process.env.REACT_APP_API_URL;
  if (!configured || isLocalUrl(configured)) {
    return DEFAULT_PRODUCTION_API_URL;
  }

  return configured.replace(/\/$/, '');
}

export function getApiOrigin() {
  const base = getApiBase();

  if (base.startsWith('http://') || base.startsWith('https://')) {
    try {
      const url = new URL(base);
      url.pathname = url.pathname.replace(/\/api\/?$/, '');
      return url.origin + url.pathname.replace(/\/$/, '');
    } catch {
      return DEFAULT_PRODUCTION_API_URL.replace(/\/api$/, '');
    }
  }

  return window.location.origin;
}

export const API_BASE = getApiBase();
